import { Next, Spinner } from '@shipengine/giger';
import { useSdk } from '@packlink/packlink-sdk-provider';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { jsx } from '@emotion/react/jsx-runtime';

function DownloadCustomsInvoice(_ref) {
  let {
    customsInvoiceId,
    onError,
    ...otherProps
  } = _ref;
  const sdk = useSdk();
  const {
    data: documentUrl,
    error,
    isLoading
  } = useQuery({
    queryKey: ['customs-invoice-url', customsInvoiceId],
    queryFn: () => sdk.v1.customsInvoices.getDocumentUrl(customsInvoiceId)
  });
  const {
    buttonProps,
    linkProps,
    ...linkComponentProps
  } = otherProps;
  const href = documentUrl === null || documentUrl === void 0 ? void 0 : documentUrl.url;
  const isDisabled = !isLoading && !href;
  useEffect(() => {
    if (error) {
      onError === null || onError === void 0 ? void 0 : onError(error);
    }
  }, [error, onError]);
  return jsx(Next.Link, {
    role: "link",
    "aria-label": "download",
    isButton: true,
    buttonProps: {
      isFullWidth: true,
      isLoading,
      spinner: jsx(Spinner, {}),
      isDisabled,
      ...buttonProps
    },
    isExternal: true,
    href: href,
    target: "_self",
    download: "download",
    ...linkComponentProps
  });
}

export { DownloadCustomsInvoice };
//# sourceMappingURL=DownloadCustomsInvoice.js.map
